import auth from "../middleware/auth";

const routes = [
  {
    path: "/account-settings",
    name: "Profile",
    component: () => import("../../views/protected/ProfilePage"),
    meta: {
      title: "Admin Profile",
      middleware: [auth],
      layout: () => import("../../layouts/protected"),
    },
  },
];

export default routes;
